<template>
  <div>
    <a href="javascript:;">
      <span class="openModalTxt" v-if="getSlotText('openModalTxt') !== ''">
        <slot name="openModalTxt">Open Txt</slot>
      </span>
      <span class="openModalClickable" @click="openModal"><slot name="openModal">Open Clickable</slot></span>
    </a>
    <SimonModal
      :show-footer-buttons="getSlotText('ifNextButton') === '1'"
      :is-visible="showModal"
      @hide="showModal = false"
      @btnLeft="showModal = false"
      @btnRight="goToUrl"
      id='modal-content-element'
      :btn-left-title="getSlotText('btnClosedSimonModal') !== '' ? getSlotText('btnClosedSimonModal') : undefined"
      :btn-cancel-title="getSlotText('btnClosedSimonModal') !== '' ? getSlotText('btnClosedSimonModal') : undefined"
      :btn-right-title="getSlotText('btnNextSimonModal') !== '' ? getSlotText('btnNextSimonModal') : undefined"
      cssClassRightButton="filled"
      :size="size"
    >
      <slot name="ModalContent"></slot>
      <template v-for="slot in possibleChildSlotsFor('SimonModal')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </SimonModal>
  </div>

</template>

<script>

import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'ContentSimonModal',
  components: { SimonModal },
  data () {
    return {
      showModal: false
    }
  },
  methods: {
    openModal () {
      this.showModal = true
    },
    goToUrl () {
      if (this.getSlotText('urlNextSimonModal')) {
        if (this.getSlotText('newTabNextSimonModal') === '1') {
          window.open(this.getSlotText('urlNextSimonModal'), '_blank')
        } else {
          window.open(this.getSlotText('urlNextSimonModal'), '_self')
        }
      }
    }
  },
  props: {
    size: {
      type: String,
      default: 'small',
      validator: function (value) {
        return ['small', 'large'].includes(value)
      }
    }
  }
}
</script>
